import React from 'react';
import rtfToText from '../../utils/rtfToText';

interface StandaloneEventItemProps {
  item: {
    EventItemId: number;
    EventItemTitle: string | null;
    EventItemAgendaNumber: string | null;
    EventItemActionName: string | null;
    EventItemAgendaNote: string | null;
    EventItemMinutesNote: string | null;
  };
}

const StandaloneEventItem: React.FC<StandaloneEventItemProps> = ({ item }) => {
  return (
    <div className="border border-gray-100 rounded-lg px-4 py-3 bg-gray-50">
      <div className="flex items-center gap-3">
        {item.EventItemAgendaNumber && (
          <span className="text-xs text-gray-500">#{item.EventItemAgendaNumber}</span>
        )}
        <span className="text-sm font-medium text-gray-700">
          {item.EventItemTitle || item.EventItemActionName || 'Agenda Item'}
        </span>
      </div>
      {item.EventItemAgendaNote && (
        <p className="text-xs text-gray-500 mt-1">{rtfToText(item.EventItemAgendaNote)}</p>
      )}
      {item.EventItemMinutesNote && (
        <p className="text-xs text-gray-500 mt-1">{rtfToText(item.EventItemMinutesNote)}</p>
      )}
    </div>
  );
};

export default StandaloneEventItem;
